import { Button } from 'antd'

import { pick } from '@eastcoal/common/utils/object'

import { AuctionOperationPageStatus } from '../../../enums/AuctionOperationPageStatus'
import { useAuctionListStore } from '../../../Store/hooks/useStore'

import { BidMemberListButtonProps } from './interface'

export const BidMemberListButton = ({ record }: BidMemberListButtonProps) => {
  const { setCurrentAuction, toggleBidMemberListModalVisible } =
    useAuctionListStore(state =>
      pick(state, ['setCurrentAuction', 'toggleBidMemberListModalVisible'])
    )

  const handleClick = () => {
    setCurrentAuction(record)
    toggleBidMemberListModalVisible()
  }

  const disabled =
    record.status === AuctionOperationPageStatus.WAIT_AUDIT ||
    record.status === AuctionOperationPageStatus.WAIT_PUBLISH

  return disabled ? null : (
    <Button type='link' onClick={handleClick}>
      竞价会员
    </Button>
  )
}
